import * as React from 'react';
import { useContext, useState } from 'react';
import { Button } from '../../../../../../shared/ui/button';
import { Flex } from '../../../../../components/common/flex';
import { UserContext } from '../../../../../components/contexts/user_context';
import { useResize } from '../../../../../hooks/use_resize';
import { useBookActions } from '../../../../bookings/hooks/use_book_actions';
import { BookCancellationModal } from '../book_cancellation_modal';
import { BookCorrectionModal } from '../book_correction_modal';
import { IApproveBookFooterProps } from './approve_book_footer.d';

export const ApproveBookFooter: React.FC<IApproveBookFooterProps> = ({
  bookId,
  bookToken,
  correctionReasons,
  cancellationReasons,
  onActionPerformed,
}) => {
  const [showCorrectionModal, setShowCorrectionModal] = useState<boolean>(false);
  const [showRejectionModal, setShowRejectionModal] = useState<boolean>(false);

  const { isExtraLargeScreen } = useResize();
  const { emitBookAction } = useBookActions();
  const userContext = useContext(UserContext);

  const bookIdOrToken = userContext.current_user.id ? { bookId } : { bookToken };

  const handleShowCorrectionModal = () => setShowCorrectionModal(true);
  const handleCloseCorrectionModal = () => setShowCorrectionModal(false);

  const handleShowRejectionModal = () => setShowRejectionModal(true);
  const handleCloseRejectionModal = () => setShowRejectionModal(false);

  const handleApproveBook = () => {
    emitBookAction({
      ...bookIdOrToken,
      action: 'approve',
      onUpdate: () => {},
      handleCloseModal: () => onActionPerformed('approve', []),
    });
  };

  const handleCorrectBook = (reasons: Array<number>) => {
    emitBookAction({
      ...bookIdOrToken,
      action: 'correct',
      onUpdate: () => {},
      handleCloseModal: () => {
        handleCloseCorrectionModal();
        onActionPerformed(
          'correct',
          correctionReasons.filter((reason) => reasons.includes(reason.value)).map((reason) => reason.text)
        );
      },
      data: { extranet_correction_reasons: reasons },
    });
  };

  const handleRejectBook = (reasonProps: { cancellation_reason: string }) => {
    emitBookAction({
      ...bookIdOrToken,
      action: 'reject',
      onUpdate: () => {},
      handleCloseModal: () => {
        handleCloseRejectionModal();
        onActionPerformed('reject', [reasonProps.cancellation_reason]);
      },
      data: reasonProps,
    });
  };

  return (
    <>
      {isExtraLargeScreen ? (
        <Flex vertical gap={'middle'} className={'approve-book-footer'}>
          <Flex gap={'middle'}>
            <Button variant={'filled'} color={'success'} style={{ flex: 1 }} onClick={handleApproveBook}>
              Подтвердить
            </Button>
            <Button variant={'outline'} color={'danger'} onClick={handleShowRejectionModal}>
              Отказаться
            </Button>
          </Flex>
          <Button variant={'outline'} onClick={handleShowCorrectionModal}>
            Скорректировать
          </Button>
        </Flex>
      ) : (
        <Flex gap={'middle'} justify={'space-between'} className={'approve-book-footer'}>
          <Flex gap={'middle'}>
            <Button variant={'filled'} color={'success'} onClick={handleApproveBook}>
              Подтвердить
            </Button>
            <Button variant={'outline'} onClick={handleShowCorrectionModal}>
              Скорректировать
            </Button>
          </Flex>
          <Button variant={'outline'} color={'danger'} onClick={handleShowRejectionModal}>
            Отказаться
          </Button>
        </Flex>
      )}
      <BookCorrectionModal
        open={showCorrectionModal}
        onClose={handleCloseCorrectionModal}
        onSubmit={handleCorrectBook}
        correctionReasons={correctionReasons}
      />
      <BookCancellationModal
        open={showRejectionModal}
        onClose={handleCloseRejectionModal}
        onSubmit={handleRejectBook}
        cancellationReasons={cancellationReasons}
      />
    </>
  );
};
